// Generated by Claude Code
import ApiUser from '#core/entities/auth/api-users/ApiUser.ts'

/** The create response: the new API user plus its one-time client secret. */
export default class ApiUserCreated extends ApiUser {
  secret: string = ''
}
